import React from 'react';
import config from 'config';
import { connect } from 'react-redux'
import axios from 'axios';
import Loading from '../App/Loading';
import { Container, Row } from 'reactstrap';
import MatTable from './components/Table/MatTable';

class ContratsCollection extends React.Component {

  constructor(props) {
    super(props)
    this.listingMapping = {
      '/contrats/pending': {
        type: 'pending',
        title: 'Contrats en attente de signature'
      },
      '/contrats/completed': {
        type: 'completed',
        title: 'Contrats signés'
      }
    }
    this.pageTitle = this.listingMapping[props.location.pathname].title;
    this.state = {
      loading: true,
      loaded: false,
      contrats: [],
      user: {
        ...props.user
      }
    }
  }

  componentDidMount() {
    const listingKey = this.listingMapping[this.props.location.pathname].type;
    axios.post(`${process.env.REACT_APP_API_ENDPOINT}/user/dashboards/annonceurs/get-sidebar/`, {
      'userid': this.props.user.id
    }).then(res => {
      const data = res.data;
      this.setState({
        ...this.state,
        contrats: data.contrats[listingKey].collection,
        loaded: true,
        loading: false
      })
    })
  }

  render() {
    const { loaded, loading } = this.state;
    return (
      <Container className="listings">
        <Loading loaded={loaded} loading={loading} />
        {
          loaded && (
            <Row>
              <MatTable history={this.props.history} data={this.state.contrats} title={this.pageTitle} />
            </Row>
          )
        }
      </Container>
    )
  }
}

const mapStateToProps = (state) => ({
  ...state.authentication
});
export default connect(mapStateToProps)(ContratsCollection);